import styled from "styled-components";
import { MEDIA_QUERIES } from "@ifgengineering/component-library";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;

  /* Too narrow to hang the tray off the bell, so it hangs off the whole bar instead. */
  @media ${MEDIA_QUERIES.PHONE} {
    position: static;
  }
`;

export const IconContainer = styled.div<{ highlight: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  white-space: nowrap;

  width: 36px;
  height: 36px;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background-color: ${({ theme, highlight }) =>
    highlight
      ? theme.colors.ui.background.insetDisabled
      : theme.colors.ui.background.inset};
`;

export const MainIcon = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
`;

export const NotificationListContainer = styled.div`
  position: absolute;
  min-width: 200px;
  right: 0;
  top: calc(100% + 0px);
  height: 70vh;
  width: 400px;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.ui.background.raised};
  display: flex;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.elevation.low};
  border-radius: 0 0 8px 8px;

  @media ${MEDIA_QUERIES.PHONE} {
    left: 0;
    width: auto;
    min-width: 0;
  }
`;

export const NotificationScrollArea = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow-y: scroll;
`;

export const NotificationBadgeHeader = styled.div`
  padding: 10px 20px;
`;

export const NotificationBadge = styled.div`
  position: absolute;
  border-radius: ${({ theme }) => theme.radius.full}px;
  width: 8px;
  height: 8px;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.ui.icon.error};
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;
